import React, { useState, useEffect } from "react";
import Singleproductdetails from "../Components/Productdetails/Singleproductdetails";
import Breadcrumb from "../Components/Breadcrumb";
import Relatedproducts from "../Components/Productdetails/Relatedproducts";
import Reviewsandcomments from "../Components/Productdetails/Reviewsandcomments";
import SpecialProducts from "../Components/Productdetails/SpecialProducts";
import Customer from "../Components/Homepage/Customer";
import Writeacomment from "../Components/Productdetails/Writeacomment";
import Productsspecification from "../Components/Productdetails/Productsspecification";
import SpecialproductsSingle from "../Components/Productdetails/SpecialproductsSingle";
import { useParams } from "react-router-dom";
import { apiurl } from "../Constants";
import AOS from "aos";
import "aos/dist/aos.css";
import { FadeLoader } from "react-spinners";
import axios from "axios";
function ProductDetailstwo() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    AOS.init({
      once: false,
    });

    const handleScroll = () => {
      AOS.refresh();
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [productDetails, setProductDetails] = useState({});
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [categoryname, setCategoryname] = useState("");
  const [subcategoryname, setSubcategoryname] = useState("");
  const [subchildcategoryname, setSubchilcCategoryname] = useState("");
  const [productname, setProductname] = useState("");
  const [loading, setLoading] = useState(true);
  const { specialproduct_id } = useParams();

  const [categoryheadingid, setCategoryheadingid] = useState("");
  const [subcategoryheadingid, setsubCategoryheadingid] = useState("");
  const [subchildcategoryheadingid, setsubchildCategoryheadingid] =
    useState("");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [specialproduct_id]);

  useEffect(() => {
    const fetchDatta = async () => {
      setLoading(true);
      await axios
        .post(apiurl + "product_detail", {
          product_id: specialproduct_id,
        })
        .then((res) => {
          const data = res.data.data;

          setProductDetails(data);
          setRelatedProducts(data.related_products);
          setCategoryname(data.category[0]?.category_name || "");
          setSubcategoryname(data.subcategory[0]?.subcategory_name || "");
          setSubchilcCategoryname(
            data.subchildcategory && data.subchildcategory[0]
              ? data.subchildcategory[0].subchildcategoryname
              : ""
          );
          const catId = JSON.parse(data.category_id)[0];
          const subcatId = JSON.parse(data.subcategory_id)[0];
          const subchildcatId = JSON.parse(data.subchildcategory_id)[0];
          setCategoryheadingid(catId);
          setsubCategoryheadingid(subcatId);
          setsubchildCategoryheadingid(subchildcatId);
          setProductname(data.product_name || "");
          setLoading(false);
        });
    };
    fetchDatta();
  }, [specialproduct_id]);

  useEffect(() => {
    AOS.init({
      once: false,
    });

    const handleScroll = () => {
      AOS.refresh();
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);


  console.log(productDetails);


  return (
    <>
      <Breadcrumb
        title_1="Home"
        title_2="Health Food"
        title_3="Groceries"
        title_4="Cooking Oil"
        title_5="Groundnut Oil"
      />
      {/* <Singleproductdetails
        productDetails={productDetails}
        overall_ratting={productDetails.overall_ratting}
      /> */}
      <SpecialproductsSingle productDetails={productDetails} />
      {/* <Productsspecification productDetails={productDetails} /> */}
      <Reviewsandcomments
        productDetails={productDetails}
        overall_ratting={productDetails.overall_ratting}
      />
      <Writeacomment product_id={specialproduct_id} />
      {relatedProducts?.length > 0 ? (
        <Relatedproducts relatedProducts={relatedProducts} />
      ) : null}
      <SpecialProducts />
      <Customer />
    </>
  );
}

export default ProductDetailstwo;
